<nwm-menu />
<div class="content">
  <div class="main">
    <div class="row my-4">
      @if (dataLoaded) {
        <div class="col-xxl-10 offset-xxl-1">
          <h1 class=" my-4">Calendar Year Donation to Funds & Grants to Charities</h1>
          <hr>
            <div class="legend">
              <i style="background:#2a3a69"></i> <b>Donations to Fund</b>
              <i style="background:#93a8a3" class="ml-5"></i> <b>Grants to Charities</b>
            </div>
            <PGFChart [data]="[yearDonations,yearGrants]" [chartLabels]="years" />
            <div class="scrollable-wrap mt-4">
              <div class="scrollable">
                <div class="scrollable-button left"></div>
                <div class="scrollable-button"></div>
                <table width="100%" class="NWMtable sticky_header table table-striped mb-0">
                  <thead>
                    <tr>
                      <td width="23%" role="button" (click)="toggleSort('year')" class="sortable">
                        <span>Year</span>
                        <i class="fa" [ngClass]="sortField === 'year' ? (sortDir<0 ? 'fa-sort-asc ml-2' : 'fa-sort-desc ml-2') : ''" aria-hidden="true"></i>
                      </td>
                      <td width="30%" role="button" class="text-right sortable" (click)="toggleSort('donations')">
                        <span>Donations</span>
                        <i class="fa" [ngClass]="sortField === 'donations' ? (sortDir<0 ? 'fa-sort-asc ml-2' : 'fa-sort-desc ml-2') : ''" aria-hidden="true"></i>
                      </td>
                      <td width="47%" role="button" class="text-right sortable" (click)="toggleSort('grants')">
                        <span>Grants</span>
                        <i class="fa" [ngClass]="sortField === 'grants' ? (sortDir<0 ? 'fa-sort-asc ml-2' : 'fa-sort-desc ml-2') : ''" aria-hidden="true"></i>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    @if (pagedData) {
                      <ng-container *ngTemplateOutlet="dataRow" />
                    }
                  </tbody>
                </table>
              </div>
            </div>
            <div class="form-inline float-right mb-4">
              <div class="form-group pt-4">
                <label for="pageSize" class="font-weight-bold">Rows Displayed</label>
                <select [(ngModel)]="pageSize" name="pageSize" class="form-control mx-sm-3" id="pageSize" (ngModelChange)="sortData()">
                  <option  [value]="0" [selected]="!pageSize">All</option>
                  @for (o of pageOptions; track o) {
                    <option [value]="o" [selected]="pageSize  === o">{{o}}</option>
                  }
                </select>
              </div>
              @if (totalPages > 1) {
                <ngb-pagination [collectionSize]="dataList.length"
                  [(page)]="page" [maxSize]="2" (pageChange)="setPage()"
                  class="pagination pt-4"
                  [pageSize]="pageSize"
                  [boundaryLinks]="true">
                  <ng-template ngbPaginationFirst>First</ng-template>
                  <ng-template ngbPaginationPrevious>Previous</ng-template>
                  <ng-template ngbPaginationNext>Next</ng-template>
                  <ng-template ngbPaginationLast>Last</ng-template>
                </ngb-pagination>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <ng-template #dataRow>
    @if (pagedData) {
      @for (row of pagedData; track row) {
        <tr>
          <td class="text-left align-middle">
            {{row.year}}
          </td>
          <td class="text-right align-middle">
            {{row.donations | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}
          </td>
          <td class="text-right align-middle">
            {{row.grants | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}
          </td>
        </tr>
      }
    }
  </ng-template>